"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _TaskDragDrop = require("./TaskDragDrop");

require("./Draggable.css");

var Draggable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Draggable, _React$Component);

  var _super = (0, _createSuper2.default)(Draggable);

  function Draggable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Draggable);
    _this = _super.call(this, props);
    _this.state = {
      clickedX: 0,
      clickedY: 0,
      width: 0,
      height: 0
    };
    _this.ref = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(Draggable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevprops.mouseDown && !this.props.mouseDown && this.props.dragging) {
        if (this.props.onDragEnd) {
          this.props.onDragEnd();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement(_TaskDragDrop.TaskDragDropContext.Consumer, null, function (value) {
        var left, top;

        if (_this2.props.dragging) {
          left = Math.min(value.maxX - _this2.ref.current.offsetWidth - _this2.state.startX, Math.max(value.minX - _this2.state.startX, value.mouseX - _this2.state.clickedX));
          top = Math.min(value.maxY - _this2.ref.current.offsetHeight - _this2.state.startY, Math.max(value.minY - _this2.state.startY, value.mouseY - _this2.state.clickedY));
        }

        return /*#__PURE__*/_react.default.createElement("div", {
          ref: _this2.ref,
          className: "draggable" + (_this2.props.dragging ? " dragging" : ""),
          "aria-hidden": _this2.props.ariaHidden,
          id: _this2.props.id,
          onMouseDown: function onMouseDown(e) {
            var rect = _this2.ref.current.getBoundingClientRect();

            _this2.setState({
              clickedX: value.mouseX,
              clickedY: value.mouseY,
              width: _this2.ref.current.offsetWidth,
              height: _this2.ref.current.offsetHeight,
              startX: rect.left,
              startY: rect.top
            });

            if (_this2.props.onDragStart) {
              _this2.props.onDragStart();
            }
          },
          style: {
            position: "relative",
            left: left,
            top: top,
            textAlign: "center",
            zIndex: _this2.props.dragging ? 999 : 1,
            width: _this2.props.labelWidth,
            height: _this2.props.labelHeight,
            backgroundColor: _this2.props.labelColor
          }
        }, _this2.props.children);
      });
    }
  }]);
  return Draggable;
}(_react.default.Component);

var _default = Draggable;
exports.default = _default;